module.exports = __webpack_public_path__ + "img/modal-sprite.67649c98.png";